import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Sidebar, Segment } from 'semantic-ui-react';

import Home from '../Home';
import Header from '../Header';
import Footer from '../Footer';
import NoMatch from '../NoMatch';
import Company from '../Company';
import Jobs from '../Jobs';
import Services from '../Services';
import Education from '../Education';
import Registration from '../Registration';
import Contact from '../Contact';
import Hospitals from '../Hospitals';
import Prices from '../Prices';
import DataProvider from '../../api/contextApi/DataProvider';
import Preview from '../Preview';
import Questions from '../Questions';
import Admin from '../Admin';

import './App.css';

class App extends Component {
  render() {
    const { location } = this.props;
    return (
      <div className="FullPage__Wrapper">
        <DataProvider>
          <Sidebar.Pushable as={Segment} className="Page__Pusher">
            <Header />
            <Sidebar.Pusher>
              <div className="Page__Pusher__MainContent container clearfix">
                <Switch location={location}>
                  <Route exact path="/" component={Home} />
                  <Route exact path="/diensten" component={Services} />
                  <Route exact path="/opleiding" component={Education} />
                  <Route exact path="/jtv" component={Company} />
                  <Route exact path="/registreer" component={Registration} />
                  <Route exact path="/jobs" component={Jobs} />
                  <Route exact path="/contact" component={Contact} />
                  <Route exact path="/klinieken" component={Hospitals} />
                  <Route exact path="/tarieven" component={Prices} />
                  <Route exact path="/faq" component={Questions} />
                  <Route exact path="/admin" component={Admin} />
                  <Route exact path="/admin/:subRoute" component={Admin} />
                  <Route exact path="/preview" render={routeProps => <Preview {...routeProps} />} />
                  <Route component={NoMatch} />
                </Switch>
              </div>
            </Sidebar.Pusher>
            <Footer />
          </Sidebar.Pushable>
        </DataProvider>
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js